import * as React from "react";
import { Helmet } from "react-helmet-async";
import { Formik } from "formik";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import {
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Table,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

// @mui
import {
  TextField,
  Card,
  Stack,
  MenuItem,
  Container,
  Typography,
  Box,
  Breadcrumbs,
} from "@mui/material";

// hooks
import useSettings from "../../hooks/useSettings";

// components
import Page from "../../components/Page";
import { useEffect } from "react";
import { useState } from "react";

// ----------------------------------------------------------------------

export default function PatientVitals_Doctor() {
  const { themeStretch } = useSettings();
  const [rows, setRows] = useState([]);
  const [id, setId] = useState("");
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  fetch(`${process.env.REACT_APP_KAIZEN_API}/api/dev4/tmpgraphs`)
    .then((response) => response.json())
    .then((data) => setUsers(data))
    .catch((error) =>
      //console.error('Error:', error)
      console.log("")
    );

  const [pname, setName] = React.useState("");
  const [email, setEmail] = React.useState("");

  const handletext = (e) => {
    setId(e.target.value);
    // console.log(id)
    axios
      .post(
        `${process.env.REACT_APP_KAIZEN_API}/api/dev4/tmpgemails`,
        JSON.stringify({ id: e.target.value })
      )
      .then((response) => {
        setName(response.data[0].pname);
        setEmail(response.data[0].email);
      })
      .catch((err) => {
        // console.log(err);
        console.log("");
      });

    axios
      .post(
        `${process.env.REACT_APP_KAIZEN_API}/api/dev3/postvital`,
        JSON.stringify({ patient_id: e.target.value })
      )
      .then((response) => {
        setRows(response.data);
      });
  };

  const isNonMobile = useMediaQuery("(min-width:600px)");

  const handleFormSubmit = (values) => {
    //console.log(values);
    console.log("");
  };

  const handleChanging = (event) => {
    setName(event.target.value);
  };
  const handleChanged = (event) => {
    setEmail(event.target.value);
  };

  return (
    <>
      <Helmet>
        <title> Patient Vitals | Kaizen Digital </title>
      </Helmet>
      <Page title="Page Two">
        <Container maxWidth={themeStretch ? false : "xl"}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Stack direction="column" spacing={0}>
              <Typography variant="h3" gutterBottom color="primary">
                Patient Vitals
              </Typography>
              <div role="presentation">
                <Breadcrumbs aria-label="breadcrumb">
                  <Typography
                    sx={{ display: "flex", alignItems: "center" }}
                    color="text.primary"
                  >
                    Dashboard
                  </Typography>
                  <Typography
                    sx={{ display: "flex", alignItems: "center" }}
                    color="text.primary"
                  >
                    Patient Vitals
                  </Typography>
                </Breadcrumbs>
              </div>
            </Stack>
          </Stack>
          <Formik onSubmit={handleFormSubmit}>
            {({ handleBlur, handleChange, handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Box>
                  <Box
                    display="grid"
                    gap="30px"
                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 4",
                      },
                    }}
                  >
                    <select
                      // value={pname}
                      label="Patient Name "
                      onChange={(e) => handletext(e)}
                      style={{
                        borderRadius: "5px",
                        borderColor: "#CDCDCD",
                        color: "#5A5A5A",
                      }}
                    >
                      {users.map((user) => (
                        <option key={user.id} value={user.id}>
                          {user.pname}
                        </option>
                      ))}
                    </select>

                    <TextField
                      id="outlined-multiline-static"
                      multiline
                      rows={1}
                      onBlur={handleBlur}
                      onChange={(e) => setEmail(e.target.value)}
                      defaultValue={email}
                      name="email"
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Box>
                </Box>
                <br />

                <Card>
                  <Box sx={{ width: "100%" }}>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">ID</TableCell>
                            <TableCell align="left">Device ID</TableCell>
                            <TableCell align="left">Device Name</TableCell>
                            <TableCell align="left">
                              Heart Rate (Pulse Rate)
                            </TableCell>
                            <TableCell align="left">
                              BP (Blood Pressure)
                            </TableCell>
                            <TableCell align="left">Weight </TableCell>
                            <TableCell align="left">Height </TableCell>
                            <TableCell align="left">Temperature</TableCell>
                            <TableCell align="left">SPO2 </TableCell>
                            <TableCell align="left">Date of Entry</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row) => (
                            <TableRow
                              //  key={row.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell
                                component="th"
                                scope="row"
                                align="left"
                              >
                                {row.patient_id}
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                align="left"
                              >
                                {row.device_id}
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                align="left"
                              >
                                {row.device_name}
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                align="left"
                              >
                                {row.heart_rate}
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                align="left"
                              >
                                {row.bp}
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                align="left"
                              >
                                {row.weight}
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                align="left"
                              >
                                {row.height}
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                align="left"
                              >
                                {row.temperature}
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                align="left"
                              >
                                {row.spo2}
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                align="left"
                              >
                                {row.date_of_joining}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Card>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </>
  );
}
